import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardHeader,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import './GeofenceCard.scss';
import { Icon } from '@iconify/react';
import constants from '../../../../../utils/constants';
import CountUp from 'react-countup';

const GeofenceCard = ({
  geofenceName,
  geoType,
  onView,
  vehicleNumber,
  isActive,
  handleDelete,
  handleDeactivate,
  onUpdate,
  onAssign,
  activeColor
}: any) => {
  return (
    <>
      <Box className='box-container'>
        <Card
          onClick={(event: React.SyntheticEvent) => {
            event.stopPropagation();
            onView();
          }}
          className={activeColor ? 'active' : 'non-active'}
        >
          <CardHeader
            avatar={
              <Avatar
                className={`card-avatar ${
                  geoType === 'circular' ? 'circular-color' : 'polygon-color'
                }`}
              >
                <Icon
                  className='card-avatar-icon'
                  icon={geoType === 'circular' ? 'wpf:geofence' : 'ph:polygon-fill'}
                />
              </Avatar>
            }
            action={
              <IconButton aria-label='settings' className='action-containers'>
                <Tooltip title={isActive === 0 ? 'Activate' : 'Deactivate'} arrow>
                  <Icon
                    className='action-geofence'
                    icon={isActive === 0 ? 'mdi:tick-circle' : 'flat-color-icons:cancel'}
                    onClick={(event: any) => {
                      event.stopPropagation();
                      handleDeactivate();
                    }}
                  />
                </Tooltip>
              </IconButton>
            }
            title={
              <Box className='geofence-name'>
                <Tooltip title={geofenceName} placement='bottom'>
                  {geofenceName}
                </Tooltip>
              </Box>
            }
            subheader={
              <Box className='geofence-sub-header'>
                <Icon
                  className={`geofence-sub-header-icon ${
                    isActive === 0 ? 'deactive-col' : 'active-col'
                  }`}
                  icon='carbon:circle-filled'
                />
                {geoType}
              </Box>
            }
          />
          <CardActions>
            <Box className='card-actions-geofence'>
              <Box className='card-geofence-divider'>
                <Tooltip title='Assign' arrow>
                  <Icon
                    className='geofence-action-icons-assign'
                    icon={isActive ? 'clarity:assign-user-solid' : 'mdi:user-off'}
                    onClick={(event: any) => {
                      event.stopPropagation();
                      if (isActive) {
                        onAssign();
                      }
                    }}
                  />
                </Tooltip>
                <Tooltip title='Update' arrow>
                  <Icon
                    className='geofence-action-icons-update'
                    icon={isActive ? 'bxs:edit' : 'material-symbols:edit-off'}
                    onClick={(event: any) => {
                      event.stopPropagation();
                      if (isActive) {
                        onUpdate();
                      }
                    }}
                  />
                </Tooltip>
                <Tooltip title='Delete' arrow>
                  <Icon
                    className='geofence-action-icons-delete'
                    icon='ic:baseline-delete'
                    onClick={(event: any) => {
                      event.stopPropagation();
                      handleDelete();
                    }}
                  />
                </Tooltip>
              </Box>

              <Typography>
                {constants?.VehicleMapped} :
                {vehicleNumber?.length > 0 ? (
                  <CountUp end={vehicleNumber?.length} duration={3} />
                ) : (
                  0
                )}
              </Typography>
            </Box>
          </CardActions>
        </Card>
      </Box>
    </>
  );
};

export default GeofenceCard;
